/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'
import { get, groupBy } from 'lodash'

/**
 * Import
 * - Actions
 */
import {
    fetchPolicyCategories,
    fetchPolicyTypes,
    fetchCountries,
    setStep00,
    findAddress,
    getAddress,
    findLatLong,
    companyNameSearch,
    resetQuotes
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step00 from '../../../components/pages/Quote/Step00/Step00'

const splitCategories = (list: any = []) => {
    var data: any = {}
    if (list.length > 0) {
        data = groupBy(list, type => type.groupTitle)
    }
    return data
}

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        address: state.address,
        companyNames: state.companyNames,
        policyCategories: state.step00.policyCategories,
        policySplitTypes: splitCategories(get(state, 'step00.policyTypes.data', [])),
        policyTypes: state.step00.policyTypes,
        countries: state.step00.countries,
    }
}

export default connect(
    mapStateToProps,
    {
        fetchPolicyCategories,
        fetchPolicyTypes,
        fetchCountries,
        setStep00,
        findAddress,
        getAddress,
        getLatLong: findLatLong,
        companyNameSearch,
        resetQuotes,
    }
)(Step00)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step00.tsx